import React, { useState, useEffect } from 'react';
import './PhotoViewer.css';

const PhotoViewer = ({ isOpen, photos, initialIndex = 0, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  useEffect(() => {
    setCurrentIndex(initialIndex);
  }, [initialIndex, isOpen]);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (!isOpen) return;
      
      switch (e.key) {
        case 'Escape':
          onClose();
          break;
        case 'ArrowLeft':
          goToPrevious();
          break;
        case 'ArrowRight':
          goToNext();
          break;
        default:
          break;
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyPress);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, currentIndex, photos.length]);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex > 0 ? prevIndex - 1 : photos.length - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex < photos.length - 1 ? prevIndex + 1 : 0
    );
  };

  const goToIndex = (index) => {
    setCurrentIndex(index);
  };

  if (!isOpen || !photos || photos.length === 0) {
    return null;
  }

  const currentPhoto = photos[currentIndex];

  return (
    <div className="photo-viewer-overlay" onClick={onClose}>
      <div className="photo-viewer-container" onClick={(e) => e.stopPropagation()}>
        {/* Bouton fermer */}
        <button className="photo-viewer-close" onClick={onClose}>
          ✕
        </button>

        {/* Compteur de photos */}
        <div className="photo-viewer-counter">
          {currentIndex + 1} / {photos.length}
        </div>

        {/* Navigation précédente */}
        {photos.length > 1 && (
          <button 
            className="photo-viewer-nav photo-viewer-nav-prev"
            onClick={goToPrevious}
            aria-label="Photo précédente"
          >
            ◀
          </button>
        )}

        {/* Image principale */}
        <div className="photo-viewer-image-container">
          <img
            src={currentPhoto.src}
            alt={currentPhoto.alt}
            className="photo-viewer-image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>

        {/* Navigation suivante */}
        {photos.length > 1 && (
          <button 
            className="photo-viewer-nav photo-viewer-nav-next"
            onClick={goToNext}
            aria-label="Photo suivante"
          >
            ▶
          </button>
        )}

        {/* Informations de la photo */}
        {currentPhoto.info && (
          <div className="photo-viewer-info">
            <p>{currentPhoto.info}</p>
          </div>
        )}

        {/* Miniatures de navigation */}
        {photos.length > 1 && (
          <div className="photo-viewer-thumbnails">
            {photos.map((photo, index) => (
              <div
                key={index}
                className={`photo-viewer-thumbnail ${
                  index === currentIndex ? 'photo-viewer-thumbnail-active' : ''
                }`}
                onClick={() => goToIndex(index)}
              >
                <img
                  src={photo.src}
                  alt={`Miniature ${index + 1}`}
                  className="photo-viewer-thumbnail-image"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotoViewer; 